import { ReviewStatus } from '../models/enums/review-status';

export class IgUsernameSuggestion {
  id: number;
  restaurantId: number;
  suggestion: string;
  status: ReviewStatus;
}
